module.exports = __webpack_public_path__ + "img/m2x8lluomudaozhu.prt.56f80aee.jpg";